import React from "react";
import { Input } from "@fluentui/react-components";
import { Field } from "./Field";
import { Control, Controller } from "react-hook-form";
import { t } from "../../i18n/i18n";

type ControlledAmountSelectorProps = {
  name: any;
  control: Control<any>;
  label: string;
  disabled?: boolean;
  required?: boolean;
};

export const ControlledAmountSelector = ({
  name,
  control,
  disabled,
  label,
  required,
}: ControlledAmountSelectorProps) => {
  const formatNumber = (value: string) => {
    return value.replace(/\D/g, ""); // Remove all non-numeric characters
  };

  return (
    <Controller
      name={name}
      control={control}
      rules={{
        required: required ? t("RequiredField") : false,
        pattern: /^[0-9]+$/,
      }}
      render={({
        field: { value, onChange },
        fieldState: { error, invalid },
        formState: { disabled: formDisabled },
      }) => {
        return (
          <Field
            label={label}
            required={required ?? false}
            validationMessage={error ? error.message : undefined}
            validationState={error ? "error" : undefined}
          >
            <Input
              type={"number"}
              value={value ? formatNumber(value.toString()) : ""}
              onChange={onChange}
              disabled={(disabled || formDisabled) ?? false}
            />
          </Field>
        );
      }}
    />
  );
};
